import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b10a4298"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg width=\"22\" height=\"22\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-b10a4298><defs data-v-b10a4298><linearGradient id=\"bellGrad\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"0%\" data-v-b10a4298><stop offset=\"0%\" stop-color=\"#FEE7D1\" data-v-b10a4298></stop><stop offset=\"100%\" stop-color=\"#FFC4A0\" data-v-b10a4298></stop></linearGradient></defs><path d=\"M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6V11c0-3.07-1.64-5.64-4.5-6.32V4a1.5 1.5 0 00-3 0v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z\" fill=\"url(#bellGrad)\" data-v-b10a4298></path></svg>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "msg-panel-drawer" }
const _hoisted_5 = { class: "msg-panel-header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "msg-panel-title" }, "我的消息", -1))
const _hoisted_7 = { class: "msg-panel-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessagePanel = _resolveComponent("MessagePanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "star-tab-bar",
      style: _normalizeStyle({
    background: _ctx.isLight ? '#f2f5fa' : '#1F1F1F',
    borderBottom: _ctx.isLight ? '1px solid #dbdfe6' : 'none'
  })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tab.key,
          class: _normalizeClass(["star-tab-item", { active: _ctx.activeTab === tab.key }]),
          style: _normalizeStyle({
        color: _ctx.activeTab === tab.key ? (_ctx.isLight ? '#fe5c5c' : '#ffffff') : (_ctx.isLight ? '#999999' : '#AAAAAA'),
        background: _ctx.activeTab === tab.key ? (_ctx.isLight ? '#ffffff' : '#2e2e2e') : 'transparent'
      }),
          onClick: ($event: any) => (_ctx.handleClick(tab))
        }, _toDisplayString(tab.label), 15, _hoisted_1))
      }), 128)),
      (_ctx.activeTab === 'home')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "tab-bell",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMessage = true))
          }, _hoisted_3))
        : _createCommentVNode("", true)
    ], 4),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showMessage)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "msg-panel-overlay",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showMessage = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", {
                  class: "msg-panel-close",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMessage = false))
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_MessagePanel, {
                  onNavigate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showMessage = false))
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}